var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 2c4.595 0 8.32 3.725 8.32 8.32-.00232 1.93478-.66417 3.715-1.7728 5.12792L21.71 20.29a1 1 0 010 1.42 1.00009 1.00009 0 01-.71.29002 1.00009 1.00009 0 01-.71-.29002l-4.84208-4.8428C14.035 17.97582 12.25478 18.63767 10.32 18.64 5.725 18.64 2 14.915 2 10.32 2 5.725 5.725 2 10.32 2zm0 2C6.82956 4 4 6.82956 4 10.32c0 3.49044 2.82956 6.32 6.32 6.32 3.49044 0 6.32-2.82956 6.32-6.32-.0055-3.48816-2.83184-6.3145-6.32-6.32z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/search.svg";
export { SvgSearch as ReactComponent };